export const FormFields = {
    ACKNOWLEDGE_TEXT: 'acknowledge-text',
};

export const ACKNOWLEDGE_TEXT_MAX_LENGTH = 200;
